//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
	// name: 'rest-prop-link',
	props:
	{
		// to:
		// {
		// 	type: String,
		// 	default: '',
		// },

		object:
		{
			type: Object,
			required: true,
		},

		toField:
		{
			type: String,
			required: true,
		},

		maxlength:
		{
			type: Number,
			default: 0
		},

		richtext:
		{
			type: Boolean,
			default: false
		},

		editable:
		{
			type: Boolean,
			default: false
		},

		url:
		{
			type: String,
			default: ''
		},

		field:
		{
			type: String,
			default: ''
		},

		modelId:
		{
			type: Number,
			default: -1,
		}
	},

}
